module.exports = __webpack_public_path__ + "static/media/appointments-available-news.1be1bfd3.jpg";